import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import logo from "./assets/shared/logo.svg";
import hamburger from "./assets/shared/icon-hamburger.svg";
import close from "./assets/shared/icon-close.svg";
import "./assets/Navigation.scss";

const Navbar = () => {
    const [nav, setNav] = useState({
        menuOpen: false,
        page: 0
    });

        const routes = [["Home", "/", 0], ["Destination", "/Destination", 1], ["Crew", "/Crew", 2], ["Technology", "/Technology", 3]];
        const links = routes.map(i => i[2] === nav.page? <li>
            <Link to={i[1]} className='active' onClick={setNav(i[2])}>{i[0]}</Link>
        </li> : <li>
            <Link to={i[1]}>{i[0]}</Link>
        </li>);

        const closeMenu = (e) => {
            setNav(prev => {
                return {...prev, menuOpen:false}
            })
        }

        const openMenu = e => {
            setNav(prev => {
                return {...prev, menuOpen:true}
            })
        }

        return(
            <>
            {/**Navigation bar */}
            <nav>
                <Link to="/"><img alt="logo" src={logo}/></Link>
                
                <div className='nav-links'>
                    {links}
                </div>

                <div className='nav-links-mobile'>
                        <img alt="hamburger" className="" src={hamburger} onClick={openMenu}/>
                        {nav.menuOpen &&<section>
                            <img alt="hamburger" className="" src={close} onClick={closeMenu}/>
                            {links}
                        </section>}
                </div>
            </nav>

            
            <Outlet/>
            </>
        )
    
}

export default Navbar;